import { render, staticRenderFns } from "./RenameModal.vue?vue&type=template&id=2d9fb943&scoped=true"
import script from "./RenameModal.vue?vue&type=script&lang=js"
export * from "./RenameModal.vue?vue&type=script&lang=js"
import style0 from "./RenameModal.vue?vue&type=style&index=0&id=2d9fb943&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9fb943",
  null
  
)

export default component.exports